export default "/images/Snaillogo.png?95f03720081b85c8474be8d17ce5c4d2";